<div class="popover-arrow arrow"></div>
<h3 class="popover-title popover-header" *ngIf="title">{{ title }}</h3>
<div class="popover-content popover-body">
  <ng-content></ng-content>
</div>